// extracted by mini-css-extract-plugin
export default {"modalContainer":"Q6","fadeIn":"R6","img":"S6","fadeInImg":"T6","greeting":"U6","fadeInGreeting":"V6","imgWrapper":"W6","name":"X6","fadeInName":"Y6"};
    if(module.hot) {
      // 1721922368620
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  